module.exports = __webpack_public_path__ + "img/Vector18.fbd957ad.svg";